import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { showErrorNotification } from '../../../core/helpers'

import { EditableTableRowLoader } from '../../../common/components/sections'

import { selectMenuCurationTaskById } from '../../redux/selectors'

const MenuCurationTaskEditableRow = ({ ...rowProps }) => {
  const rowRef = useRef(null)
  const { 'data-row-key': id, children, className, ...restProps } = rowProps

  const { isLoading, error } =
    useSelector(state => selectMenuCurationTaskById(state, id)) || {}

  useEffect(() => {
    if (!isNil(error)) {
      showErrorNotification({
        title: 'Menu curation task update failed',
        description: error,
      })
    }
  }, [error])

  return (
    <>
      <EditableTableRowLoader
        isLoading={isLoading}
        height={rowRef?.current?.offsetHeight}
      />
      <tr data-row-key={id} ref={rowRef} className={className} {...restProps}>
        {children}
      </tr>
    </>
  )
}

MenuCurationTaskEditableRow.propTypes = {
  rowProps: PropTypes.object,
}

MenuCurationTaskEditableRow.defaultProps = {
  rowProps: undefined,
}

export default MenuCurationTaskEditableRow
